export function clearIdentity() {
  return {
    type: 'CLEAR_IDENTITY'
  }
}

export function devCheatIdentify(patientId, displayname) {
  return {
    type: 'STORE_PATIENT_IDENTIFICATION/VERIFY_CREATE',
    result: { patient_id: patientId, displayname }
  }
}
